import { toast } from "react-toastify";
import { requestBackendReportExport } from "./backendReportExport";

export const SEARCH_TERM_INSIGHTS_REPORT_TYPE = "SEARCH_TERM";

/** Prefer display name key (innerKeys.productName) over id key for export columns. */
export function getSearchTermV2VisibleColumnKeys(columns = []) {
  return columns
    .map((column) => {
      if (typeof column === "string") return column;
      return column?.innerKeys?.productName ?? column?.key;
    })
    .filter(Boolean);
}

export function buildSearchTermV2WrapperExportQueryBody({ query }) {
  return {
    query: { ...query },
  };
}

export async function exportSearchTermV2Report({
  clientId,
  userPlatform = "amazon",
  triggeredBy,
  totalCount,
  queryBody,
  visibleColumnKeys,
  frontendConfig = {},
  setIsExporting = () => {},
  onExportSuccess = () => {},
}) {
  try {
    setIsExporting(true);

    await requestBackendReportExport({
      clientId,
      userPlatform,
      reportType: SEARCH_TERM_INSIGHTS_REPORT_TYPE,
      totalCount,
      triggeredBy,
      queryBody,
      frontendConfig: {
        columns: visibleColumnKeys,
        ...frontendConfig,
      },
    });

    onExportSuccess();
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.message ?? "Failed to submit export request."
    );
  } finally {
    setIsExporting(false);
  }
}
